/**
 * Initialize all scripts after DOMContentLoaded
 */
document.addEventListener( "DOMContentLoaded", function() {
	initFancybox();
	initFiltrationRangeSliders();
	initSelectDropdowns();
	initProductsFiltration();
	initNavSubmenu();
	initMobileMenu();
	initAccordions();
	initLoadMore();
	initInstafeedSwiper();
	initFormsObserver();
} );

document.addEventListener( "shopify:section:load", function( e ) {
	initAccordions( e.target );
	initInstafeedSwiper( e.target );
} );

/**
 * Shopify theme editor: cleanup per-section observers
 */
document.addEventListener( "shopify:section:unload", function( e ) {
	const host = e.target && e.target.querySelector ? e.target.querySelector( "#insta-feed" ) : null;
	if ( host && host._instafeedSwiperObserver ) {
		host._instafeedSwiperObserver.disconnect();
		host._instafeedSwiperObserver = null;
	}
} );

/**
 * Initialize fancybox
 */
function initFancybox() {
	if ( !window.Fancybox ) return;

	Fancybox.bind( "[data-fancybox]", {
		dragToClose: true,
		placeFocusBack: true
	} );
}

/**
 * Initialize range sliders
 */
function initFiltrationRangeSliders() {
	if ( !window.rangeSlider ) return;

	let sliders = document.querySelectorAll( ".s-range-input" );

	sliders.forEach( ( slider ) => {
		let min_range = parseInt( slider.dataset.range_min || 0 );
		let max_range = parseInt( slider.dataset.range_max || 0 );
		let min_value = parseInt( slider.dataset.value_min || min_range );
		let max_value = parseInt( slider.dataset.value_max || max_range );
		const wrapper = slider.closest( ".s-range-filter" );
		const labelMin = wrapper.querySelector( ".range-filter__label--min" );
		const labelMax = wrapper.querySelector( ".range-filter__label--max" );
		const sliderSettings = {
			min: min_range,
			max: max_range,
			value: [min_value, max_value],
			onInput: function( [newMin, newMax] ) {
				if ( slider.classList.contains( "price-filter" ) ) {
					const inputMin = wrapper.querySelector( '.range-filter__input-min' );
					const inputMax = wrapper.querySelector( '.range-filter__input-max' );
					if ( inputMin ) inputMin.value = newMin;
					if ( inputMax ) inputMax.value = newMax;
					inputMin.dispatchEvent( new Event( "change", { bubbles: true } ) );
					inputMax.dispatchEvent( new Event( "change", { bubbles: true } ) );
				} else {
					const inputList = wrapper.querySelector( '.range-filter__input-list' );
					if ( inputList ) {
						let values = [];
						if ( slider.classList.contains( "length-filter" ) ) {
							for (
								let i = Math.round( newMin * 10 );
								i <= Math.round( newMax * 10 );
								i++
							) {
								values.push( (i / 10).toFixed( 1 ) );
							}
						} else {
							for ( let i = newMin; i <= newMax; i++ ) {
								values.push( i );
							}
						}
						inputList.value = values.join( "," );
						inputList.dispatchEvent( new Event( "change", { bubbles: true } ) );
					}
				}

				if ( labelMin ) labelMin.textContent = formatRangeLabelValue( slider, newMin );
				if ( labelMax ) labelMax.textContent = formatRangeLabelValue( slider, newMax );
			}
		};

		if ( slider.classList.contains( "length-filter" ) ) {
			sliderSettings.step = 0.1;
		} else if ( slider.classList.contains( "price-filter" ) ) {
			sliderSettings.step = 1000;
		}

		rangeSlider( slider, sliderSettings );
	} );
}

/**
 * Initialize select dropdowns
 */
function initSelectDropdowns() {
	document.querySelectorAll( ".s-dropdown-select__label" ).forEach( ( dropdown ) => {
		dropdown.addEventListener( "click", function( e ) {
			e.preventDefault();
			let wrapper = dropdown.closest( ".s-dropdown-select" );
			wrapper.classList.toggle( "s-dropdown-select--active" );
		} )
	} );

	document.addEventListener( "click", function( e ) {
		document.querySelectorAll( ".s-dropdown-select.s-dropdown-select--active" ).forEach( ( activeDropdown ) => {
			if ( !activeDropdown.contains( e.target ) ) {
				activeDropdown.classList.remove( "s-dropdown-select--active" );
			}
		} );
	} );

	document.querySelectorAll( ".s-dropdown-select__item input[type='checkbox'], .s-dropdown-select__item input[type='radio']" ).forEach( ( checkbox ) => {
		checkbox.addEventListener( "change", function() {
			const wrapper = checkbox.closest( ".s-dropdown-select" );
			const label = wrapper.querySelector( ".s-dropdown-select__label" );
			const defaultLabel = label.dataset.default_label || "Select";
			const checked = wrapper.querySelectorAll( "input[type='checkbox']:checked, input[type='radio']:checked" );

			if ( !checked.length ) {
				label.textContent = defaultLabel;
				return;
			}

			let values = [];
			checked.forEach( ( input ) => {
				const item = input.closest( ".s-dropdown-select__item" );
				if ( item ) values.push( item.textContent.trim() );
			} );

			if ( values.length <= 2 ) {
				label.textContent = values.join( ", " );
			} else {
				label.textContent = values.length + " selected";
			}

		} );
	} );
}

/**
 * Initialize products filtration
 */
function initProductsFiltration() {
	const runFilterDebounced = debounce( function( e ) {
		const sectionId = window.sectionLoopId;
		if ( !sectionId ) return;

		const filtersSectionId = window.filtersSectionId;
		const currentSection = document.querySelector( `#shopify-section-${sectionId}` );
		const loopBlock = currentSection.querySelector(
			`#shopify-section-${sectionId} .s-block-loop`
		);
		const oldProductsWrapper = loopBlock.querySelector( '.s-loop-wrapper' );
		const form = e.target.closest( 'form' );
		let params = new URLSearchParams( new FormData( form ) );
		let reloadFilters = false;

		blockUI( loopBlock );
		blockUI( form );

		for ( const [key, value] of params.entries() ) {
			if ( !value ) params.delete( key );
		}

		let basePath = window.location.pathname;

		if ( params && params.has( 'collection' ) ) {
			const collectionPath = params.get( 'collection' );
			if ( collectionPath === basePath.replace( /\/$/, '' ) ) {
				params.delete( 'collection' );
			} else {
				params = '';
				reloadFilters = true;
			}

			basePath = collectionPath;
		}

		let query = params.toString();
		query = query.replace( /%2C/g, ',' );
		let url = basePath + (query ? "?" + query : "");

		if ( params && params.has( 'tag' ) ) {
			const tag = params.get( 'tag' );
			params.delete( 'tag' );

			let basePath = window.location.pathname.replace( /\/tagged\/[^\/]+/i, '' );
			url = basePath.replace( /\/$/, '' ) + '?' + (params.toString() ? params.toString() + '&' : '') + 'tag=' + encodeURIComponent( tag );
		}

		loadSections( url, [sectionId, filtersSectionId] )
			.then( ( sections ) => {
				const newProductsSection = sections[sectionId];
				const newFiltersSection = sections[filtersSectionId];

				// PRODUCTS
				if ( newProductsSection && oldProductsWrapper ) {
					const newProductsWrapper = newProductsSection.querySelector( '.s-loop-wrapper' );
					if ( newProductsWrapper ) {
						oldProductsWrapper.replaceWith( newProductsWrapper );
					}
				}

				// FILTERS
				if ( newFiltersSection && reloadFilters ) {
					const oldFiltersSection = document.querySelector( `#shopify-section-${filtersSectionId}` );

					if ( oldFiltersSection ) {
						oldFiltersSection.replaceWith( newFiltersSection );
					}
				}
			} )
			.catch( ( err ) => {
				console.error( err );
			} )
			.finally( () => {
				unblockUI( form );
				unblockUI( loopBlock );
				// initLoadMore();
				if ( reloadFilters ) {
					initFiltrationRangeSliders();
					initSelectDropdowns();
				}
				window.history.pushState( {}, "", url );
			} );
	}, 800 );

	document.addEventListener( 'change', function( e ) {
		if ( e.target.matches( '.s-filter-input' ) ) {
			runFilterDebounced( e );
		}
	} );

	document.addEventListener( 'input', function( e ) {
		if ( e.target.matches( '.s-filter-input' ) ) {
			runFilterDebounced( e );
		}
	} );

	document.addEventListener( 'submit', function( e ) {
		if ( e.target.matches( '.s-loop-filtration__form' ) ) {
			e.preventDefault();
			runFilterDebounced( e );
		}
	} );
}

/**
 * Initialize load more buttons
 */
function initLoadMore() {
	document.addEventListener('click', async function (e) {
		const button = e.target.closest('.s-load-more .button');
		if (!button) return;

		e.preventDefault();

		if (button.dataset.loading === 'true') return;
		button.dataset.loading = 'true';
		button.setAttribute('aria-busy', 'true');

		const url = button.dataset.next_url;
		const sectionId = button.dataset.section_id;

		const loopBlock = document.querySelector(
			`#shopify-section-${sectionId} .s-block-loop`
		);
		if (!loopBlock) {
			delete button.dataset.loading;
			button.removeAttribute('aria-busy');
			return;
		}

		const loadMoreWrapper = loopBlock.querySelector('.s-load-more');
		if (!url || !sectionId || !loadMoreWrapper) {
			delete button.dataset.loading;
			button.removeAttribute('aria-busy');
			return;
		}

		blockUI(loopBlock);

		try {
			const newSections = await loadSections(url, [sectionId]);
			if (!newSections) return;

			const newSection = newSections[sectionId];
			if (!newSection) return;

			const newItems = newSection.querySelectorAll('.s-loop-item');
			const newLoadMore = newSection.querySelector('.s-load-more');

			if (newItems.length && loadMoreWrapper) {
				newItems.forEach(el => {
					loadMoreWrapper.before(el);
				});

				if (newLoadMore) {
					loadMoreWrapper.replaceWith(newLoadMore);
				} else {
					loadMoreWrapper.remove();
				}
			}
		} catch (err) {
			console.error(err);
		} finally {
			delete button.dataset.loading;
			button.removeAttribute('aria-busy');
			unblockUI(loopBlock);
		}
	});
}

/**
 * Load section via Shopify API
 *
 * @param url
 * @param sectionIds
 * @returns {Promise<Element>}
 */
async function loadSections( url, sectionIds ) {
	const separator = url.includes( '?' ) ? '&' : '?';

	const sectionsParam = Array.isArray( sectionIds )
		? sectionIds.join( ',' )
		: sectionIds;

	const r = await fetch( url + separator + "sections=" + sectionsParam );
	const sections = await r.json();

	const parser = new DOMParser();
	const result = {};

	for ( const id in sections ) {
		const html = sections[id];
		if ( !html ) continue;

		const doc = parser.parseFromString( html, "text/html" );
		result[id] = doc.querySelector( ".shopify-section" );
	}

	return result;
}

/**
 * Format money value
 *
 * @param value
 * @returns {string}
 */
function formatMoney( value ) {
	return new Intl.NumberFormat( 'en-US', {
		style: 'currency',
		currency: 'USD',
		maximumFractionDigits: 0
	} ).format( value );
}

/**
 * Format range slider label value
 *
 * @param slider
 * @param value
 * @returns {*|string}
 */
function formatRangeLabelValue( slider, value ) {
	if ( slider.classList.contains( "price-filter" ) ) {
		return formatMoney( value );
	}

	if ( slider.classList.contains( "length-filter" ) ) {
		return value + "ft";
	}

	if ( slider.classList.contains( "year-filter" ) ) {
		return value;
	}

	return value;
}

/**
 * Debounce function
 *
 * @param callback
 * @param time
 * @returns {(function(): void)|*}
 */
function debounce( callback, time ) {
	let timeout;

	return function() {
		const context = this;
		const args = arguments;
		if ( timeout ) {
			clearTimeout( timeout );
		}
		timeout = setTimeout( function() {
			timeout = null;
			callback.apply( context, args );
		}, time );
	};
}

/**
 * Block UI by adding a class
 *
 * @param element
 */
function blockUI( element ) {
	element.classList.add( "s-loading" );
}

/**
 * Unblock UI by removing a class
 *
 * @param element
 */
function unblockUI( element ) {
	element.classList.remove( "s-loading" );
}

/**
 * Show submenu on hover
 */
function initNavSubmenu() {
	const menuItems = document.querySelectorAll( '.s-advanced-menu__item.has-dropdown' );

	menuItems.forEach( menuItem => {
		let hideTimeout;
		const caret = menuItem.querySelector( '.link-item__caret' );

		const show = () => {
			if ( window.innerWidth < 1024 ) return;
			clearTimeout( hideTimeout );
			menuItem.classList.add( 'sub-menu-active' );
			caret.setAttribute( 'aria-expanded', 'true' );
		};

		const hide = () => {
			if ( window.innerWidth < 1024 ) return;
			hideTimeout = setTimeout( () => {
				menuItem.classList.remove( 'sub-menu-active' );
				caret.setAttribute( 'aria-expanded', 'false' );
			}, 300 );
		};

		// hover
		menuItem.addEventListener( 'mouseover', show );
		menuItem.addEventListener( 'mouseout', hide );

		// keyboard (Tab)
		menuItem.addEventListener( 'focusin', show );
		menuItem.addEventListener( 'focusout', hide );
	} );
}

/**
 * Show the mobile menu and dropdown on click
 */
function initMobileMenu() {
	document.querySelectorAll( '.s-advanced-menu__toggle' ).forEach( toggle => {
		toggle.addEventListener( 'click', ( e ) => {
			let menu = toggle.closest( '.s-advanced-menu' ).querySelector( '.s-advanced-menu__mobile' );
			menu.classList.toggle( 'menu-opened' );
			toggle.classList.toggle( 'menu-opened' );

			if ( menu.classList.contains( 'menu-opened' ) ) {
				toggle.setAttribute( 'aria-expanded', 'true' );
			} else {
				toggle.setAttribute( 'aria-expanded', 'false' );
			}
		} );
	} );

	document.querySelectorAll( '.s-advanced-menu__mobile .s-advanced-menu__item .link-item__caret' ).forEach( caret => {
		caret.addEventListener( 'click', ( e ) => {
			e.preventDefault();
			let item = caret.closest( '.s-advanced-menu__item' );
			let dropdown = item.querySelector( '.s-advanced-menu__dropdown' );
			item.classList.toggle( 'sub-menu-active' );

			if ( item.classList.contains( 'sub-menu-active' ) ) {
				dropdown.style.height = dropdown.scrollHeight + 'px';
				caret.setAttribute( 'aria-expanded', 'true' );
			} else {
				dropdown.style.height = 0;
				caret.setAttribute( 'aria-expanded', 'false' );
			}
		} );
	} );
}

/**
 * Initialize accordion blocks
 */
const _accordionInit = new WeakSet();
const _accordionItemInit = new WeakSet();

function initAccordions( root = document ) {
	root.querySelectorAll( ".s-accordion[data-accordion]" ).forEach( ( accordion ) => {
		if ( _accordionInit.has( accordion ) ) return;
		_accordionInit.add( accordion );

		const singleOpen = accordion.dataset.accordionSingle === "true";
		const openFirst = accordion.dataset.accordionOpenFirst === "true";
		const items = Array.from( accordion.querySelectorAll( "details.s-accordion__item" ) );

		if ( openFirst && items.length && !items.some( ( i ) => i.open ) ) {
			items[0].open = true;
		}

		items.forEach( ( item ) => setupAccordionItem( item, accordion, items, singleOpen ) );
	} );
}

function setupAccordionItem( item, accordion, items, singleOpen ) {
	if ( _accordionItemInit.has( item ) ) return;
	_accordionItemInit.add( item );

	const summary = item.querySelector( ".s-accordion__summary" );
	const panel = item.querySelector( ".s-accordion__panel" );
	if ( !summary || !panel ) return;

	// Initial state: keep open panels visible.
	panel.style.overflow = "hidden";
	panel.style.height = item.open ? "auto" : "0px";

	summary.addEventListener( "click", function( e ) {
		e.preventDefault();
		if ( item.dataset.animating === "true" ) return;

		const willOpen = !item.open;

		if ( willOpen && singleOpen ) {
			items.forEach( ( other ) => {
				if ( other !== item && other.open ) closeAccordionItem( other );
			} );
		}

		if ( willOpen ) openAccordionItem( item );
		else closeAccordionItem( item );
	} );
}

function getAccordionDuration( detailsEl ) {
	const accordion = detailsEl.closest( ".s-accordion" );
	if ( !accordion ) return 250;
	const duration = parseInt( getComputedStyle( accordion ).getPropertyValue( "--accordion-duration" ) || "250", 10 );
	return isNaN( duration ) ? 250 : duration;
}

function openAccordionItem( detailsEl ) {
	const panel = detailsEl.querySelector( ".s-accordion__panel" );
	if ( !panel ) return;
	const duration = getAccordionDuration( detailsEl );

	detailsEl.dataset.animating = "true";
	detailsEl.open = true;

	// From 0px -> scrollHeight
	panel.style.height = "0px";
	const target = panel.scrollHeight;

	requestAnimationFrame( () => {
		panel.style.transitionDuration = duration + "ms";
		panel.style.height = target + "px";
	} );

	const onEnd = function( e ) {
		if ( e.propertyName !== "height" ) return;
		panel.removeEventListener( "transitionend", onEnd );
		panel.style.height = "auto";
		detailsEl.dataset.animating = "false";
	};
	panel.addEventListener( "transitionend", onEnd );
}

function closeAccordionItem( detailsEl ) {
	const panel = detailsEl.querySelector( ".s-accordion__panel" );
	if ( !panel ) return;
	const duration = getAccordionDuration( detailsEl );

	detailsEl.dataset.animating = "true";

	// From current height -> 0px
	const start = panel.scrollHeight;
	panel.style.height = start + "px";

	requestAnimationFrame( () => {
		panel.style.transitionDuration = duration + "ms";
		panel.style.height = "0px";
	} );

	const onEnd = function( e ) {
		if ( e.propertyName !== "height" ) return;
		panel.removeEventListener( "transitionend", onEnd );
		detailsEl.open = false;
		detailsEl.dataset.animating = "false";
	};
	panel.addEventListener( "transitionend", onEnd );
}

/**
 * Turn Instafeed grid into Swiper slider.
 */
function initInstafeedSwiper( root = document ) {
	if ( !window.Swiper ) return;

	const host = (root && root.querySelector) ? (root.querySelector( "#insta-feed" ) || document.querySelector( "#insta-feed" )) : document.querySelector( "#insta-feed" );
	if ( !host ) return;

	// Ensure enough slides for Swiper loop when slidesPerView is large.
	const desktopSlidesPerView = 4;
	const minLoopSlides = (Math.ceil( desktopSlidesPerView ) * 2) + 2;

	/**
	 * Instafeed lazy-loader won't handle duplicated slides, so we force `src`.
	 */
	const setInstafeedImagesSrc = ( el ) => {
		el.querySelectorAll( "img" ).forEach( ( img ) => {
			const dataSrc = img.getAttribute( "data-instafeed-src" ) || img.getAttribute( "data-src" ) || img.getAttribute( "data-lazy" );
			if ( dataSrc ) {
				img.setAttribute( "src", dataSrc );
				img.classList.add( "instafeed-lazy-image--handled" );
			}
		} );
	};

	const ensureSwiperControlEl = ( container, className ) => {
		let el = container.querySelector( "." + className );
		if ( el ) return el;
		el = document.createElement( "div" );
		el.className = className;
		container.appendChild( el );
		return el;
	};

	const canUpdateExistingSwiper = ( container, wrapper ) => {
		if ( container.dataset.instafeed_swiper !== "true" ) return false;
		if ( !container.swiper ) return false;
		if ( !wrapper.classList.contains( "swiper-wrapper" ) ) return false;
		if ( wrapper.querySelectorAll( ".swiper-slide" ).length < 2 ) return false;
		return true;
	};

	const initInstafeedContainerSwiper = ( container ) => {
		const wrapper = container.querySelector( ".instafeed-new-layout-wrapper" );
		if ( !wrapper ) return false;

		// If Swiper is already running here and markup still matches, just keep it updated.
		if ( canUpdateExistingSwiper( container, wrapper ) ) {
			try {
				container.swiper.update();
				return true;
			} catch ( e ) {
				// Fall through to rebuild.
			}
		}

		// Remove old duplicates (safety).
		wrapper.querySelectorAll( '[data-instafeed-swiper-dup="true"]' ).forEach( ( el ) => el.remove() );

		let slides = Array.from( wrapper.querySelectorAll( ".instafeed-new-layout-item" ) );
		if ( slides.length < 2 ) return false;

		if ( slides.length < minLoopSlides ) {
			const base = slides.slice();
			let i = 0;
			while ( slides.length < minLoopSlides && base.length ) {
				const clone = base[i % base.length].cloneNode( true );
				clone.setAttribute( "data-instafeed-swiper-dup", "true" );
				setInstafeedImagesSrc( clone );
				wrapper.appendChild( clone );
				i++;
				slides = Array.from( wrapper.querySelectorAll( ".instafeed-new-layout-item" ) );
			}
		}

		// Instafeed lazy-loader won't handle our duplicated slides.
		wrapper.querySelectorAll( '[data-instafeed-swiper-dup="true"]' ).forEach( ( dup ) => setInstafeedImagesSrc( dup ) );

		container.classList.add( "swiper", "s-instafeed-swiper" );
		wrapper.classList.add( "swiper-wrapper" );
		container.removeAttribute( "data-instafeed-prevent-touch-scroll" );

		// Remove Instafeed inline grid sizing (inline styles beat CSS).
		wrapper.style.display = "";
		wrapper.style.gridTemplateColumns = "";
		wrapper.style.gap = "";
		container.style.width = "";
		container.style.height = "";

		slides.forEach( ( item ) => {
			item.classList.add( "swiper-slide" );
			item.style.width = "";
			item.style.height = "";
		} );

		const prev = ensureSwiperControlEl( container, "swiper-button-prev" );
		const next = ensureSwiperControlEl( container, "swiper-button-next" );
		const pagination = container.querySelector( ".swiper-pagination" );
		if ( pagination ) pagination.remove();

		if ( container.swiper ) container.swiper.destroy( true, true );
		container.dataset.instafeed_swiper = "true";

		new Swiper( container, {
			loop: true,
			watchOverflow: false,
			grabCursor: true,
			// centeredSlides: true,
			centeredSlidesBounds: true,
			observer: true,
			observeParents: true,
			loopAdditionalSlides: 2,
			slidesPerView: desktopSlidesPerView,
			breakpoints: {
				0: {
					slidesPerView: 2,
				},
				768: {
					slidesPerView: 3,
				},
				1024: {
					slidesPerView: desktopSlidesPerView,
				},
			},
			initialSlide: 1,
			spaceBetween: 13,
			navigation: {
				prevEl: prev,
				nextEl: next
			},
		} );

		return true;
	};

	const initAllInstafeedContainerSwipers = () => {
		const containers = Array.from( host.querySelectorAll( ".instafeed-new-layout-container" ) );
		containers.forEach( ( container ) => initInstafeedContainerSwiper( container ) );
	};

	// Debounced runner so MutationObserver doesn't thrash.
	if ( !host._instafeedSwiperScheduleInit ) {
		let t = null;
		host._instafeedSwiperScheduleInit = () => {
			if ( t ) clearTimeout( t );
			t = setTimeout( initAllInstafeedContainerSwipers, 60 );
		};
	}

	// Observe Instafeed injecting/replacing its grid (better than polling/resize).
	if ( !host._instafeedSwiperObserver && window.MutationObserver ) {
		host._instafeedSwiperObserver = new MutationObserver( ( mutations ) => {
			for ( const m of mutations ) {
				if ( m.type !== "childList" ) continue;
				if ( (m.addedNodes && m.addedNodes.length) || (m.removedNodes && m.removedNodes.length) ) {
					host._instafeedSwiperScheduleInit();
					break;
				}
			}
		} );
		host._instafeedSwiperObserver.observe( host, { childList: true, subtree: true } );
	}

	// Run once for already-present markup.
	initAllInstafeedContainerSwipers();
}

/**
 * Apply styles to the Shopify forms
 *
 * @param el
 */
function applyStylesToForm( el ) {
	if ( !el.shadowRoot ) return;

	const shadow = el.shadowRoot;
	if ( shadow.__stylesApplied ) return;
	shadow.__stylesApplied = true;

	const sheet = new CSSStyleSheet();
	let styles = `
	[class*="_container_"] {
			justify-content: stretch;
		}
		
		#form-container-ref [class*="_formHeader_"] {
			display: none;
		}
		
		#form-container-ref [class*="_formContainer_"]{
			margin: 0;
		}
		
		#form-container-ref [class*="_formFieldset_"]{
			padding: 0;
			gap: var(--form-row-gap, 17px) var(--form-column-gap, 15px);
			flex-wrap: wrap;
		}
		
		#form-container-ref [class*="_formFieldset_"] > div:first-child{
			display: none;
		}
		
		#form-container-ref input[type="text"], 
		#form-container-ref textarea, 
		#form-container-ref select {
			text-transform: uppercase;
			letter-spacing: 0.14em;
			font-family: var( --forms-input-font-family, var(--forms-body-font));
		}
		
		#form-container-ref textarea {
			min-height: 185px;
		}
		
		#form-container-ref input[type="text"] + label, 
		#form-container-ref textarea + label {
			text-transform: uppercase;
			font-size: 14px;
			letter-spacing: 0.14em;
			line-height: 1;
			font-weight: 500;
			transform: none;
			font-family: var( --forms-label-font-family, var(--forms-body-font));
		}
		
		#form-container-ref input[type="text"]:focus-within + label, 
		#form-container-ref textarea:focus-within + label, 
		#form-container-ref label[class*="_inputFilled_"] {
			opacity: 0;
		}
		
		#form-container-ref button[type="submit"] {
			text-transform: uppercase;
			font-size: 14px;
			line-height: 1.5;
			letter-spacing: 0.14em;
			font-weight: 500;
			border: 1px solid var(--button-background-color);
			text-align: center;
			transition: all 0.3s ease;
			font-family: var(--button-font-family, var(--forms-body-font));
		}
	`;

	if ( el.closest( '.s-footer-form' ) ) {
		styles += `
			#form-container-ref [class*="_formFieldset_"] {
				flex-direction: row;
				gap: 0;
				flex-wrap: nowrap;
			}
			
			@media screen and (max-width: 640px) {
				#form-container-ref [class*="_formFieldset_"] {
					flex-direction: column;
					gap: 17px 15px;
				}
			}
			
			#form-container-ref [class*="_formFieldContainer_"]{
				width: 75%;
			}
			
			@media screen and (max-width: 640px) {
				#form-container-ref [class*="_formFieldContainer_"]{
					width: 100%;
				}
			}
			
			#form-container-ref button[type="submit"] {
				width: 25%;
				font-size: 12px;
				display: flex;
				align-items: center;
				white-space: nowrap;
			}
			
			@media screen and (max-width: 640px) {
				#form-container-ref button[type="submit"]{
					width: auto;
					display: inline-block;
				}
			}
			
			#form-container-ref [class*="_formError_"]{
				position: absolute;
				bottom: -2px;
				left: 0;
				width: 100%;
			}

			[class*="_appEmbedRoot"] [class*="_formBannerContainer"] {
				background: #0E2230;
    			padding: 15px;
				margin: 0;
			}
			`;
	} else if ( el.closest( '.s-contact-us-form' ) ) {
		styles += `
			#form-container-ref [class*="_formFieldset_"] {
				flex-direction: row;
			}
			
			#form-container-ref [class*="_formFieldContainer_"] {
				width: 100%;
			}
			
			#form-container-ref [class*="_formFieldContainer_"]:nth-child(n+2):nth-child(-n+5) {
				width: calc( 50% - var(--form-column-gap) / 2);
			}
			
			@media screen and (max-width: 640px) {
				#form-container-ref [class*="_formFieldContainer_"]:nth-child(n+2):nth-child(-n+5) {
					width: 100%;
				}
			}
			
			#form-container-ref [class*="_formSubmitButton_"] {
				width: 100%;
			}
			
			#form-container-ref [class*="_formError_"]{ 
				display: none;
			}
			`;
	}

	sheet.replaceSync( styles );

	shadow.adoptedStyleSheets = [
		...shadow.adoptedStyleSheets,
		sheet
	];
}

/**
 * Initializes a mutation observer to monitor the DOM for added Shopify forms and applies
 * styles to them when they are detected. The observer listens for changes in the
 * document's body and ensures any existing forms are styled upon initialization.
 *
 * @return {void} This method does not return a value.
 */
function initFormsObserver() {
	const observer = new MutationObserver( mutations => {
		mutations.forEach( mutation => {
			mutation.addedNodes.forEach( node => {
				if ( node.tagName === 'SHOPIFY-FORMS-EMBED' ) {
					applyStylesToForm( node );
				}

				if ( node.querySelectorAll ) {
					node.querySelectorAll( 'shopify-forms-embed' )
						.forEach( applyStylesToForm );
				}
			} );
		} );
	} );

	observer.observe( document.body, {
		childList: true,
		subtree: true
	} );

	document.querySelectorAll( 'shopify-forms-embed' ).forEach( applyStylesToForm );
}
